import React from 'react';

import { EventoMarcadoresFormComp } from 'pages/calendario/evento/marcadores/components/pages/MarcadoresForm';
import { EventoMarcadoresListComp } from 'pages/calendario/evento/marcadores/components/pages/MarcadoresList';
import { FormProvider } from 'context/FormContext';
import { ListagemProvider } from 'context/ListagemContext';
import { usePermissionsContext } from 'context/PermissionsContext';

export function EventoMarcadoresList() {
    const { hasPermission, alertNotPermission } = usePermissionsContext();
    if (!hasPermission(['CALENDARIO_EVENTO_MARCADOR_GERENCIAR'])) return alertNotPermission();

    return (
        <ListagemProvider>
            <EventoMarcadoresListComp />
        </ListagemProvider>
    );
}

export function EventoMarcadoresForm() {
    const { hasPermission, alertNotPermission } = usePermissionsContext();
    if (!hasPermission(['CALENDARIO_EVENTO_MARCADOR_GERENCIAR'])) return alertNotPermission();

    return (
        <FormProvider>
            <EventoMarcadoresFormComp />
        </FormProvider>
    );
}
